import { useIntl } from 'react-intl'

import { Typography } from '@gto/ui/typography'

type DetailRowProps = {
  label: string
  value?: string
  mono?: boolean
}

const DetailRow = ({ label, value, mono }: DetailRowProps) => (
  <div className="flex items-center justify-between">
    <Typography
      color="text.secondary"
      variant="caption"
    >
      {label}
    </Typography>
    <Typography
      className={mono === true ? 'font-mono text-[0.8rem]' : undefined}
      variant="body2"
    >
      {value != null && value !== '' ? value : '—'}
    </Typography>
  </div>
)

export type PayoutDetailsViewProps = {
  method: string
  details: Record<string, string>
}

export const PayoutDetailsView = ({ method, details }: PayoutDetailsViewProps) => {
  const { formatMessage } = useIntl()

  switch (method) {
    case 'PAYPAL':
      return (
        <div className="flex flex-col gap-2">
          <DetailRow
            label={formatMessage({ id: 'settings.paypal.email' })}
            value={details.email}
          />
        </div>
      )
    case 'WISE':
      return (
        <div className="flex flex-col gap-2">
          <DetailRow
            label={formatMessage({ id: 'settings.wise.fullName' })}
            value={details.full_name}
          />
          <DetailRow
            label={formatMessage({ id: 'settings.wise.email' })}
            value={details.email}
          />
        </div>
      )
    case 'CRYPTO':
      return (
        <div className="flex flex-col gap-2">
          <DetailRow
            label={formatMessage({ id: 'settings.crypto.network' })}
            value={details.network}
          />
          <DetailRow
            mono
            label={formatMessage({ id: 'settings.crypto.address' })}
            value={details.address}
          />
        </div>
      )
    case 'WIRE':
      return (
        <div className="flex flex-col gap-2">
          <DetailRow
            label={formatMessage({ id: 'settings.wire.bankName' })}
            value={details.bank_name}
          />
          <DetailRow
            label={formatMessage({ id: 'settings.wire.accountHolder' })}
            value={details.account_holder}
          />
          <DetailRow
            mono
            label={formatMessage({ id: 'settings.wire.iban' })}
            value={details.iban}
          />
          <DetailRow
            mono
            label={formatMessage({ id: 'settings.wire.swift' })}
            value={details.swift}
          />
        </div>
      )
    default:
      return null
  }
}
